import angular from 'angular';
import ListingComponent from './components/listing';
import ViewComponent from './components/view';
import {OrderConfig} from './components/order.config';
import uiRouter from 'angular-ui-router';
import Orders from './services/order.service';
import OrdersDataProvider from './services/order.dataprovider.service';

export default angular.module('orders', [uiRouter])
  .component('ordersListing', ListingComponent)
  .component('orderView', ViewComponent)
  .service('Orders', Orders)
  .service('OrdersDataProvider', OrdersDataProvider)
  .config(OrderConfig)
  .name


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/orders/index.js
 **/